export default __webpack_public_path__ + "static/media/spendCategoryGroceries32.a6f72238.svg";